var _rect, _rect2, _mask, _path, _path2, _path3, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIconLightGrayRoundedLightGrayBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#F2F3F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#D0D3E2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5365_3288",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.219 16H26.6793V26.0001C26.6793 27.1047 25.7839 28.0001 24.6793 28.0001H15.219C14.1144 28.0001 13.219 27.1047 13.219 26.0001V16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.219 16H26.6793V26.0001C26.6793 27.1047 25.7839 28.0001 24.6793 28.0001H15.219C14.1144 28.0001 13.219 27.1047 13.219 26.0001V16Z",
    fill: "#D0D3E2",
    stroke: "#D0D3E2",
    strokeWidth: 8,
    mask: "url(#path-2-inside-1_5365_3288)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13H28V15H12V13Z",
    fill: "#D0D3E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0327 12.4783C16.2144 12.1812 16.5376 12 16.8858 12H23.0124C23.3607 12 23.6839 12.1812 23.8656 12.4783L24.6602 13.7778H15.238L16.0327 12.4783Z",
    fill: "#D0D3E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.00344,
    height: 2.25149,
    transform: "matrix(0.708752 -0.705458 0.718986 0.695024 16 24.3926)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9.00028,
    height: 2.25228,
    transform: "matrix(-0.695805 -0.718231 0.731492 -0.68185 22.3079 26)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconLightGrayRoundedLightGrayBorder);
export default __webpack_public_path__ + "static/media/trashIconLightGrayRoundedLightGrayBorder.08a9a2d827a739389fa2656ebdade01f.svg";
export { ForwardRef as ReactComponent };